import { useNotification } from 'admin';
import { isFieldErrorResponse, useApiAccountsV1SignupVerifyCreate } from 'api';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import { OtpForm, type OtpFormValues } from '../../components/OtpForm/OtpForm';
import { OtpIcon } from '../../components/OtpIcon/OtpIcon';
import { getAuthRoute } from '../../utils/getAuthRoute';

export const SignUpVerify = () => {
  const { open } = useNotification();
  const navigate = useNavigate();

  const { mutate, isPending } = useApiAccountsV1SignupVerifyCreate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          open?.({
            description:
              error?.response?.data.email_verification_code?.[0] ?? error?.response?.data.non_field_errors?.[0],
            message: 'Error verifying passcode',
            type: 'error',
          });
          return;
        }
        open?.({
          message: 'Error verifying passcode',
          type: 'error',
        });
      },
      onSuccess() {
        navigate(getAuthRoute('/sign-up/company'));
      },
    },
  });
  const handleSubmit = (data: OtpFormValues) => {
    mutate({
      data,
    });
  };
  return (
    <AuthLayout
      title="Trade recyclables the smart way"
      subtitle="You are only a few steps away from creating your account and getting started with Safi."
    >
      <OtpIcon variant="email" />
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Welcome to Safi!
      </Typography>
      <Typography>Check your email. We&apos;ve sent a one-time passcode to sign in to Safi.</Typography>

      <OtpForm onSubmit={handleSubmit} isLoading={isPending} />

      <Link component={RouterLink} to={getAuthRoute('/sign-up')}>
        Go back
      </Link>
    </AuthLayout>
  );
};
